import React from "react";
import cross from "../../assets/images/cross.png";
import crossIcon from "../../assets/images/cross-icon.png";
import "./confirmModel.css";

const FailModel = ({
  onClose,
  errorMessage,
  title = "Uh Oh!",
  introMessage = "Your booking could not be processed.",
  outroMessage = "Please try again.",
  actionLabel = "Try Again",
}) => {
  return (
    <div className="confirmModelContainer p-4">
      <div className="confirmModelWrapper p-4 relative">
        {/* Close icon at top-right */}
        <div
          className="absolute top-4 right-4 cursor-pointer"
          onClick={onClose}
        >
          <img src={cross} alt="Close" className="w-5 h-5" />
        </div>

        <div className="flex flex-col w-full justify-center items-center text-center text-neutral-400 text-lg py-4 px-6">
          {/* Icon */}
          <div className="mb-2 w-20 h-20">
            <img src={crossIcon} alt="Failed Icon" />
          </div>

          {/* Heading & Message */}
          <div className="mt-3">
            <h1 className="text-3xl font-bold text-black">{title}</h1>
            <div className="py-4 text-base text-neutral-600">
              <p>{introMessage}</p>
              {errorMessage ? <p>{errorMessage}</p> : null}
              <p>{outroMessage}</p>
            </div>
          </div>

          {/* Try Again Button */}
          <button className="back-bu" onClick={onClose}>
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FailModel;
